enum DeviceType {
  DESKTOP = 'Desktop',
  MOBILE = 'Mobile',
  TABLET = 'Tablet',
  OTHER = 'Other',
}

export default DeviceType;
